import script from "./inbox-talking-points-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./inbox-talking-points-card.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__